import { orderRoute } from './Orders';

export const topBar = [
	{
		key: '1',
		route: orderRoute,
		label: 'Orders'
	}
];
